module.exports = __webpack_public_path__ + "media/images/country_flags/at-78f52a660fa92902f26467278fd977d2.png";